const MILISEC_IN_MINUTE = 60000;
const MILISEC_IN_DAY = 86400000;
const MILISEC_IN_HOUR = 3600000;

export const formattedDate = (date, locale) => {
  let localeType;

  switch (locale) {
    case 'ru':
      localeType = 'ru-RU';
      break;
    case 'de':
      localeType = 'de-DE';
      break;
    case 'es':
      localeType = 'es-ES';
      break;
    default:
      localeType = 'en-GB';
  }

  const formattedDate = new Intl.DateTimeFormat(localeType, {
    timeZone: 'Europe/Moscow',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(date));

  return formattedDate.replace(/\./g, '').replace(/\s?г\.?$/i, '');
};

const getDayWordRu = (n) => {
  const abs = Math.abs(n);

  if (abs % 100 >= 11 && abs % 100 <= 14) {
    return `осталось ${n} дней`;
  }

  switch (abs % 10) {
    case 1:
      return `остался ${n} день`;
    case 2:
    case 3:
    case 4:
      return `осталось ${n} дня`;
    default:
      return `осталось ${n} дней`;
  }
};

const getTimeZoneOffset = (date, timeZone) => {
  const dtf = new Intl.DateTimeFormat('en-US', {
    timeZone,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const parts = dtf.formatToParts(date);
  const map = {};
  for (const p of parts) if (p.type !== 'literal') map[p.type] = p.value;

  const asUTC = Date.UTC(
    Number(map.year),
    Number(map.month) - 1,
    Number(map.day),
    Number(map.hour),
    Number(map.minute),
    Number(map.second)
  );

  return (asUTC - date.getTime()) / MILISEC_IN_MINUTE;
};

const zonedTimeToUtc = ({ y, mo, d, h, mi, s }, timeZone, presently) => {
  let utcMs = Date.UTC(y, mo - 1, d, h, mi, s);
  let offset1 = getTimeZoneOffset(presently, timeZone);
  utcMs -= offset1 * MILISEC_IN_MINUTE;
  let offset2 = getTimeZoneOffset(presently, timeZone);
  if (offset2 !== offset1) utcMs -= (offset2 - offset1) * MILISEC_IN_MINUTE;

  return new Date(utcMs);
};

export const diffFromMoscowTime = (dateTimeStr, presently, locale) => {
  const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/.exec(dateTimeStr);
  if (!m) return 0;

  const [_, Y, MO, D, H, MI, S] = m;
  const targetUtc = zonedTimeToUtc({ y: +Y, mo: +MO, d: +D, h: +H, mi: +MI, s: +S }, 'Europe/Moscow', presently);

  const diffMs = targetUtc.getTime() - Date.now();
  if (diffMs <= 0) return 0;

  if (diffMs >= MILISEC_IN_DAY * 2) {
    const days = Math.ceil(diffMs / MILISEC_IN_DAY);

    let daysTimer = '';

    switch (locale) {
      case 'ru':
        daysTimer = getDayWordRu(days);
        break;
      case 'de':
        daysTimer = `noch ${days} Tage`;
        break;
      case 'es':
        daysTimer = `quedan ${days} días`;
        break;
      default:
        daysTimer = `${days} days left`;
    }

    return daysTimer;
  }

  const hours = Math.floor(diffMs / MILISEC_IN_HOUR);
  const minutes =
    Math.floor((diffMs % MILISEC_IN_HOUR) / MILISEC_IN_MINUTE) < 1
      ? 1
      : Math.floor((diffMs % MILISEC_IN_HOUR) / MILISEC_IN_MINUTE);

  let returnTime = '';

  switch (locale) {
    case 'ru':
      returnTime = `осталось ${hours}ч ${minutes}м`;
      break;
    case 'de':
      returnTime = `noch ${hours} Std. ${minutes} Min.`;
      break;
    case 'es':
      returnTime = `quedan ${hours}h ${minutes}m`;
      break;
    default:
      returnTime = `${hours}h ${minutes}m left`;
  }

  return returnTime;
};
